import { interpolateRgb } from 'd3'

export const CHALLENGES = [
  'electricity',
  'transportation',
  'manufacturing',
  'buildings',
  'agriculture',
] as const

export const CHALLENGES_PENTA_FORCES_ORDER = [
  'agriculture',
  'transportation',
  'buildings',
  'electricity',
  'manufacturing',
] as const

export const LULUCF = 'LULUCF'

export type Challenge = typeof CHALLENGES[number]

export type ChallengesMap<T> = {
  [K in Challenge]: T
}

export const CHALLENGES_TITLES = {
  agriculture: 'Agriculture',
  transportation: 'Transportation',
  /** @deprecated */
  transport: 'Transportation',
  buildings: 'Buildings',
  electricity: 'Electricity',
  manufacturing: 'Manufacturing',
} as const

export const CHALLENGES_COLORS = {
  agriculture: '#FC6452',
  transportation: '#57CAFF',
  /** @deprecated */
  transport: '#57CAFF',
  buildings: '#FF5595',
  electricity: '#31E8CB',
  manufacturing: '#CC67F3',
} as const

// prettier-ignore
export const CHALLENGES_ICONS_PATHS_16PX = {
  agriculture: 'M5,6H4V2H5Zm6-6H10V4h1Zm3,10.25-3,2V15H10V12.26L8,10.92v1.33l-3,2V16H4V14.26l-3-2V4H2V5.66L4.51,7.34,7,5.67V2H8V3.67l2.5,1.67L13,3.66V2h1ZM13,4.87,11,6.21V8.05l2-1.34ZM10,6.21,8,4.86V6.71l2,1.34ZM7,6.87,5,8.21v1.84L7,8.7Zm-5,0V8.71l2,1.34V8.21Zm2,6.2V11.25L2,9.91v1.8Zm3-2.81V9.91L5,11.25v1.81l2-1.35Zm3,.81V9.25L8,7.91v1.8Zm3-1.35V7.92L11,9.26v1.8Z',
  transportation: 'M15.71 8l-2.24-2.24-1.97-1.97-7 7L1.71 8 8 1.72V4h1V0H5v1h2.31L.29 8l4.21 4.21 7-7 .15.14L14.29 8 8 14.28V12H7v4h4v-1H8.69l7.02-7z',
  /** @deprecated */
  transport: 'M15.71 8l-2.24-2.24-1.97-1.97-7 7L1.71 8 8 1.72V4h1V0H5v1h2.31L.29 8l4.21 4.21 7-7 .15.14L14.29 8 8 14.28V12H7v4h4v-1H8.69l7.02-7z',
  buildings: 'M13 9l-2 .8v1.08l2-.8 2 .81V14h-5V.11l-10 2V15h16v-4.84L13 9zm-4 5H1V2.91l8-1.58V14zM4 4H3v2h1V4zm2 0h1v2H6V4zM4 7H3v2h1V7zm2 0h1v2H6V7zm-2 3H3v2h1v-2zm2 0h1v2H6v-2z',
  electricity: 'M4 2H3V1H2v1H1v1h1v1h1V3h1V2zM15 13h-3v1h3v-1zM9.98.01h-.6l-6.41 9h3.04v-1h-1.1l3.47-4.87-2.39 12.87h.58l6.45-9.02H9.99v1h1.08l-3.48 4.88L9.98.01z',
  manufacturing: 'M11.01 1v7.17l-5-2.54v1.12l6 3.05V2h3v12h-14L1 7.25l5 2.54V8.67L0 5.62.01 15h16V1h-5z',
} as const

export const YEARS_COLORS_GRADIENT = {
  electricity: ['#5CB5A7', '#31E8CB'],
  agriculture: ['#B0766F', '#FC6452'],
  /** @deprecated **/
  transport: ['#4F93B3', '#57CAFF'],
  transportation: ['#4F93B3', '#57CAFF'],
  buildings: ['#B37089', '#FF5595'],
  manufacturing: ['#9467A6', '#CC67F3'],
} as const

export const YEARS_EXTENT = [1990, 2020]

function whiter(c: string, n = 0.3) {
  return interpolateRgb('white', c)(n)
}

export const PALETTE_GRADIENT_TO_WHITE = {
  electricity: [CHALLENGES_COLORS.electricity, whiter(CHALLENGES_COLORS.electricity)],
  agriculture: [CHALLENGES_COLORS.agriculture, whiter(CHALLENGES_COLORS.agriculture)],
  manufacturing: [CHALLENGES_COLORS.manufacturing, whiter(CHALLENGES_COLORS.manufacturing)],
  transportation: [CHALLENGES_COLORS.transportation, whiter(CHALLENGES_COLORS.transportation)],
  /** @deprecated **/
  transport: [CHALLENGES_COLORS.transport, whiter(CHALLENGES_COLORS.transport)],
  buildings: [CHALLENGES_COLORS.buildings, whiter(CHALLENGES_COLORS.buildings)],
}